export const RESET_PASSWORD = "reset_password"
export const RESET_PASSWORD_SUCCESSFUL = "reset_password_successfull"
export const RESET_PASSWORD_FAILED = "reset_password_failed"
